import React from 'react'
import { Component } from 'reflux'
import { PurchaseOrderStore, PurchaseOrderStoreActions } from 'Stores/purchaseOrderStore'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import _ from 'lodash'
import Showdown from 'showdown'
import { toast } from 'react-toastify'
import { STATUS } from '../../stores/purchaseOrderStore'
import Proxies from '../../components/proxies'
import {
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Divider,
  Box,
  Checkbox,
  CircularProgress
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import IconButton from '@material-ui/core/IconButton'
import AssignmentIcon from '@material-ui/icons/Assignment'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'
import PersonIcon from '@material-ui/icons/Person'
import HouseIcon from '@material-ui/icons/House'
import ListAltIcon from '@material-ui/icons/ListAlt'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import ReportProblemIcon from '@material-ui/icons/ReportProblem'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty'
import BlockIcon from '@material-ui/icons/Block'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import SmsIcon from '@material-ui/icons/Sms'
import CommentSection from '../../components/commentSection'
import { canMarkPurchaseOrderPaid, isPrepayOrder, purchaseOrderStatusLabel } from '../../util/purchaseOrderWorkflow'

const { GET, POST } = Proxies

export default class PurchaseOrderForm extends Component {
  constructor(props) {
    super(props)
    this.stores = [PurchaseOrderStore]
    this.storeKeys = [
      'status',
      'purchaseOrderDetails',
      'suppliers',
      'msbAdminUsers',
      'products',
      'currencies',
      'showProductsLoading',
      'pdfBlob',
      'pdfBytes',
      'showPdfFailed',
      'pdfReady',
      'redirectToSend',
      'payingPurchaseOrderID'
    ]
    this.state = {
      newLine: {
        productVariationID: '',
        productVariationUID: '',
        description: '',
        amountOfProducts: 1,
        pricePerItem: 0,
        orderLineType: '',
        orderLineID: null,
        colli: 0,
        descriptionTouched: false
      },
      editingLineIndex: null,
      selectedUser: '',
      expandedGroupKey: null,
      editGroupData: null,
      editGroupAmount: null,
      editGroupPrice: null,
      newPurchaseOrder: false,
      redirectToSend: false,
      orderLineTypeDialogOpen: false,
      orderLineTypeDialogIdx: null,
      showPassword: false,
      orderLineTypeDialogType: null,
      orderLineTypeDialogNote: '',
      selectedLineIndices: [],
      orderLineTypeDialogIndices: [],
      downloadingPdf: false,
      markErrorDialogOpen: false,
      markErrorStep: 'select',
      markErrorType: null,
      markErrorWeek: '',
      markErrorPreviews: [],
      markErrorLoadingPreviews: false,
      markErrorSending: false
    }
    this._variationColliMap = new Map()
    this._lastProductsSupplierId = null
  }

  componentDidMount() {
    PurchaseOrderStoreActions.getSuppliers()
    PurchaseOrderStoreActions.getMsbAdminUsers()
    const id = _.get(this.props, 'match.params.PurchaseOrderID')
    if (id) {
      this.setState({ newPurchaseOrder: false })
    } else {
      this.setState({ newPurchaseOrder: true })
      PurchaseOrderStoreActions.createEmptyPurchaseOrderDetails()
    }
    this.buildVariationColliMap()

    const supId = _.get(this.state, 'purchaseOrderDetails.supplier.SupplierID') || _.get(this.state, 'purchaseOrderDetails.supplierID')
    if (supId) {
      this.fetchProducts(supId)
      this._lastProductsSupplierId = supId
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.products !== prevState.products) {
      this.buildVariationColliMap()
    }

    const curSupId = _.get(this.state, 'purchaseOrderDetails.supplier.SupplierID') || _.get(this.state, 'purchaseOrderDetails.supplierID')
    if (curSupId && curSupId !== this._lastProductsSupplierId) {
      this.fetchProducts(curSupId)
      this._lastProductsSupplierId = curSupId
    }
  }

  buildVariationColliMap = () => {
    const map = new Map()
    ;(this.state.products || []).forEach(p => {
      const colli = Number(p.colli) || 0
      ;(p.variations || []).forEach(v => {
        map.set(v.VariationID, colli)
      })
    })
    this._variationColliMap = map
  }

  getColliForVariation = variationID => {
    return Number(this._variationColliMap.get(variationID)) || 0
  }

  isLocked = () => {
    const status = this.state.purchaseOrderDetails?.purchaseOrderStatus
    return !!status && status !== 'NEW'
  }

  openMarkErrorDialog = () => {
    this.setState({
      markErrorDialogOpen: true,
      markErrorStep: 'select',
      markErrorType: null,
      markErrorWeek: '',
      markErrorPreviews: []
    })
  }

  closeMarkErrorDialog = () => {
    this.setState({ markErrorDialogOpen: false })
  }

  getMarkErrorTemplate = (type, data) => {
    if (type === 'RESTORDRE') {
      return `Kære ${data.userName},

Vi skriver vedrørende din ordre ${data.ConfirmationID}.

Følgende varer er desværre i restordre hos vores leverandør:
${data.productLines}

Vi forventer at modtage varerne på lager i uge ${data.week}, hvorefter de hurtigst muligt bliver afsendt til dig.

Har du bestilt andre varer, vil disse blive afsendt snarest muligt.

Vi beklager ventetiden mange gange.

Hilsen
Upgrader`
    }
    return `Kære ${data.userName},

Vi skriver vedrørende din ordre ${data.ConfirmationID}.

Følgende varer er desværre udgået hos vores leverandør, og vi må derfor annullere denne del af din ordre:
${data.productLines}

Dine point for disse varer er tilbageført, og du er velkommen til at bestille noget andet.

Vi beklager ulejligheden mange gange.

Hilsen
Upgrader`
  }

  buildMarkErrorPreviews = async () => {
    this.setState({ markErrorLoadingPreviews: true, markErrorStep: 'preview', markErrorPreviews: [] })
    const type = this.state.markErrorType
    const week = this.state.markErrorWeek
    const lines = this.state.purchaseOrderDetails.purchaseOrderlines || []
    const selectedIndices = this.state.selectedLineIndices
    const linesWithOrder = []
    const linesWithoutOrder = []
    selectedIndices.forEach(idx => {
      const line = lines[idx]
      if (!line) return
      if (line.orderLineType === 'ORDER' && line.orderID) {
        linesWithOrder.push({ ...line, _idx: idx })
      } else {
        linesWithoutOrder.push({ ...line, _idx: idx })
      }
    })

    const byOrderId = {}
    linesWithOrder.forEach(line => {
      if (!byOrderId[line.orderID]) byOrderId[line.orderID] = []
      byOrderId[line.orderID].push(line)
    })

    const previews = []
    for (const orderIdKey of Object.keys(byOrderId)) {
      const orderID = Number(orderIdKey)
      const groupLines = byOrderId[orderIdKey]
      const productLines = groupLines.map(l => `- ${l.description} (antal: ${l.amountOfProducts})`).join('\n')
      try {
        const order = await GET('orders/fetch', { OrderID: orderID })
        if (!order || order.error || !order.UserID) throw new Error('Order not found')
        const userData = await GET('user/getNotifyUserData', { UserID: order.UserID })
        if (!userData || userData.error) throw new Error('User not found')
        const message = this.getMarkErrorTemplate(type, {
          userName: (userData.userName || '').split(' ')[0] || userData.userName,
          brandName: userData.brandName,
          ConfirmationID: order.ConfirmationID,
          productLines,
          week
        })
        previews.push({
          key: `order-${orderID}`,
          hasOrder: true,
          hasError: false,
          OrderID: orderID,
          ConfirmationID: order.ConfirmationID,
          UserID: order.UserID,
          userName: userData.userName,
          userEmail: userData.userEmail,
          notificationType: userData.userNotificationType === 'MOBILE' ? 'MOBILE' : 'EMAIL',
          message,
          lineIndices: groupLines.map(l => l._idx)
        })
      } catch (err) {
        previews.push({
          key: `order-error-${orderID}`,
          hasOrder: true,
          hasError: true,
          OrderID: orderID,
          message: '',
          lineIndices: groupLines.map(l => l._idx)
        })
      }
    }

    if (linesWithoutOrder.length) {
      previews.push({
        key: 'no-order',
        hasOrder: false,
        hasError: false,
        message: '',
        lineIndices: linesWithoutOrder.map(l => l._idx)
      })
    }

    this.setState({ markErrorPreviews: previews, markErrorLoadingPreviews: false, markErrorStep: 'preview' })
  }

  updateMarkErrorPreviewMessage = (key, message) => {
    this.setState(prev => ({
      markErrorPreviews: prev.markErrorPreviews.map(p => (p.key === key ? { ...p, message } : p))
    }))
  }

  sendMarkErrorPreviews = async () => {
    this.setState({ markErrorSending: true })
    const type = this.state.markErrorType
    const week = this.state.markErrorWeek
    const noteSuffix =
      type === 'RESTORDRE'
        ? `Restordre - uge ${week} - kunde informeret ${new Date().toISOString().slice(0, 10)}`
        : `Udgået - kunde informeret ${new Date().toISOString().slice(0, 10)}`

    let sentCount = 0
    let failedCount = 0
    const affectedIndices = new Set()

    for (const preview of this.state.markErrorPreviews) {
      preview.lineIndices.forEach(idx => affectedIndices.add(idx))
      if (!preview.hasOrder || preview.hasError || !preview.message) continue
      try {
        let message = preview.message
        if (preview.notificationType === 'EMAIL') {
          const converter = new Showdown.Converter({ simpleLineBreaks: true })
          message = converter.makeHtml(preview.message)
        }
        const response = await POST('user/notifyUser', {
          UserID: preview.UserID,
          OrderID: preview.OrderID,
          message,
          notificationType: preview.notificationType
        })
        if (response && !response.error) {
          sentCount++
          await POST('comments/createComment', {
            relatedType: 'Order',
            relatedID: preview.OrderID,
            message: noteSuffix
          })
        } else {
          failedCount++
        }
      } catch (err) {
        failedCount++
      }
    }

    const updatedLines = (this.state.purchaseOrderDetails.purchaseOrderlines || []).map((line, idx) => {
      if (!affectedIndices.has(idx)) return line
      const existingNote = line.purchaseOrderLineNote ? `${line.purchaseOrderLineNote}\n` : ''
      return { ...line, purchaseOrderLineNote: `${existingNote}${noteSuffix}` }
    })
    PurchaseOrderStoreActions.updatePurchaseOrderField({ target: { name: 'purchaseOrderlines', value: updatedLines } })

    if (sentCount) toast.success(`${sentCount} besked(er) sendt`, { autoClose: 3000 })
    if (failedCount) toast.error(`${failedCount} besked(er) kunne ikke sendes`, { autoClose: 4000 })

    this.setState({
      markErrorSending: false,
      markErrorDialogOpen: false,
      selectedLineIndices: []
    })
  }

  handleSetOrderLineType = type => {
    const idx = this.state.orderLineTypeDialogIdx
    if (idx !== null && idx !== undefined) {
      const poDetails = this.state.purchaseOrderDetails
      const updatedLines = [...(poDetails.purchaseOrderlines || [])]
      updatedLines[idx] = { ...updatedLines[idx], orderLineType: type }
      PurchaseOrderStoreActions.updatePurchaseOrderField({
        target: { name: 'purchaseOrderlines', value: updatedLines }
      })
    }
    this.setState({ orderLineTypeDialogOpen: false, orderLineTypeDialogIdx: null })
  }

  formatDate(dateString) {
    if (!dateString) return ''
    const d = new Date(dateString)
    if (isNaN(d)) return ''
    return d.toISOString().slice(0, 10)
  }

  fetchProducts(supplierId) {
    PurchaseOrderStoreActions.getProductsFromSupplier(supplierId)
  }

  handleLineFieldChange = e => {
    const { name, value } = e.target
    let newValue = value
    if (name === 'pricePerItem') newValue = value.replace(',', '.')
    this.setState(prev => ({
      newLine: {
        ...prev.newLine,
        [name]: newValue,
        descriptionTouched: name === 'description' ? true : prev.newLine.descriptionTouched
      }
    }))
  }

  handleAddLine = e => {
    e.preventDefault()
    const { productVariationID, productVariationUID, description, amountOfProducts, pricePerItem, colli } = this.state.newLine
    if (!productVariationID || !description || !amountOfProducts || !pricePerItem) return
    const linesToAdd = []
    const lineColli = Number(colli) || this.getColliForVariation(productVariationID) || 0
    for (let i = 0; i < Number(amountOfProducts); i++) {
      linesToAdd.push({
        productVariationID,
        productVariationUID,
        description,
        amountOfProducts: 1,
        pricePerItem: Number(pricePerItem),
        amountReceived: 0,
        orderLineType: '',
        orderLineID: null,
        colli: lineColli
      })
    }
    linesToAdd.forEach(line => PurchaseOrderStoreActions.addPurchaseOrderLine(line))
    this.setState({
      newLine: { productVariationID: '', description: '', amountOfProducts: 1, pricePerItem: 0, colli: 0 }
    })
  }

  handleRemoveLine = idx => {
    PurchaseOrderStoreActions.removePurchaseOrderLine(idx)
  }

  getProductOptions = () => {
    const products = this.state.products || []
    const diverseOption = {
      label: '99999 - Diverse',
      ProductID: 99999,
      elementTitle: 'Diverse',
      colli: 0,
      productVariationID: 999992,
      productVariationUID: 999991,
      variations: [
        {
          VariationID: 999994,
          variationUID: 'N/A',
          variationTitle: 'Standard'
        }
      ],
      productPrice: 0
    }
    return [
      diverseOption,
      ...products.map(product => ({
        label: `${product.ProductID} - ${product.elementTitle}`,
        ProductID: product.ProductID,
        elementTitle: product.elementTitle,
        colli: product.colli,
        ...product
      }))
    ]
  }

  getVariationOptions = selectedProduct => {
    if (!selectedProduct) return []
    return (selectedProduct.variations || []).map(variation => ({
      label: variation.variationTitle && variation.variationTitle.trim() !== '' ? variation.variationTitle : 'Standard',
      ...variation
    }))
  }

  sanitizeDropshipDescriptions = () => {
    const po = this.state.purchaseOrderDetails || {}
    const isDropship = po.isDropShip || po.orderType === 'Dropship' || po?.supplier?.isDropship
    if (!isDropship) return
    const sanitized = (po.purchaseOrderlines || []).map(l => ({
      ...l,
      description: (l.description || '').split('\n')[0].trim()
    }))
    PurchaseOrderStoreActions.updatePurchaseOrderField({ target: { name: 'purchaseOrderlines', value: sanitized } })
  }

  updatePurchaseOrderType = e => {
    const v = e.target.value
    if (v && v === 'Almindelig') {
      this.sanitizeDropshipDescriptions()
    }
    PurchaseOrderStoreActions.updatePurchaseOrderField({ target: { name: 'orderType', value: v } })
    PurchaseOrderStoreActions.updatePurchaseOrderField({ target: { name: 'isDropShip', value: v === 'Dropship' } })
  }

  getDataForPDFGeneration = () => {
    PurchaseOrderStoreActions.savePurchaseOrderRedirectToSend()
  }

  groupOrderLines = lines => {
    const grouped = {}
    lines.forEach((line, idx) => {
      const sortKey = `${line.productVariationUID}||${line.description}`
      const colli = Number(line.colli) || this.getColliForVariation(line.productVariationID) || 0
      if (!grouped[sortKey]) {
        grouped[sortKey] = {
          ...line,
          colli,
          amountOfProducts: Number(line.amountOfProducts),
          amountReceived: Number(line.amountReceived) || 0,
          _indices: [idx]
        }
      } else {
        grouped[sortKey].amountOfProducts += Number(line.amountOfProducts)
        grouped[sortKey].amountReceived += Number(line.amountReceived) || 0
        grouped[sortKey]._indices.push(idx)
      }
    })
    return Object.values(grouped)
  }

  groupOrderLinesForPdf = lines => {
    const grouped = {}
    lines?.forEach((line, idx) => {
      const key = `${line.productVariationID}||${line.description}`
      if (!grouped[key]) {
        grouped[key] = { ...line, amountOfProducts: Number(line.amountOfProducts), _indices: [idx] }
      } else {
        grouped[key].amountOfProducts += Number(line.amountOfProducts)
        grouped[key]._indices.push(idx)
      }
    })
    return Object.values(grouped)
  }

  allLinesHaveType = () => {
    const lines = _.get(this.state, 'purchaseOrderDetails.purchaseOrderlines') || []
    return lines.length === 0 ? true : lines.every(l => !!l.orderLineType)
  }

  waitForPdfReady = (timeoutMs = 15000, intervalMs = 200) =>
    new Promise((resolve, reject) => {
      const start = Date.now()
      const tick = () => {
        if (this.state.pdfReady && this.state.pdfBlob) return resolve()
        if (Date.now() - start > timeoutMs) return reject(new Error('PDF timeout'))
        setTimeout(tick, intervalMs)
      }
      tick()
    })

  handleDownloadPdf = async () => {
    try {
      this.setState({ downloadingPdf: true })
      const poDetails = this.state.purchaseOrderDetails || {}
      const supplier = poDetails.supplier || {}
      const isDanish = typeof supplier.corporateIdentificationNumber === 'string' && !/^[A-Za-z]/.test(supplier.corporateIdentificationNumber)
      const orderLines = this.groupOrderLinesForPdf(poDetails.purchaseOrderlines || [])
      const taxPercent = isDanish ? 0.25 : 0.0
      const taxBase = orderLines.reduce((sum, line) => sum + Number(line.pricePerItem) * Number(line.amountOfProducts), 0)
      const taxAmount = isDanish ? (taxBase * taxPercent).toFixed(2) : 0
      const totalAmount = (taxBase + parseFloat(taxAmount)).toFixed(2)
      const pdfData = {
        isDanish: isDanish,
        purchaseOrderNumber: poDetails.purchaseOrderNumber,
        dateCreated: this.formatDate(poDetails.dateCreated),
        supplierName: supplier.supplierName || '',
        supplierUID: supplier.supplierUID || '',
        email: poDetails.alternativeMail ? poDetails.alternativeMail : supplier.email,
        supplierAddress: supplier.address || '',
        currency: poDetails.currency || 'DKK',
        orderType: poDetails.orderType || 'Almindelig',
        deliveryAddress: poDetails.isDropShip
          ? isDanish
            ? 'Se nedenfor'
            : 'See below'
          : [
              poDetails.deliveryAddress1,
              poDetails.deliveryAddress2,
              poDetails.deliveryAddress3,
              poDetails.deliveryAddress4,
              poDetails.deliveryAddress5
            ]
              .filter(Boolean)
              .join(', '),
        ourRef: poDetails.ourRef || '',
        theirRef: poDetails.theirRef || ' ',
        alternativeDeliveryTime: this.formatDate(poDetails.alternativeDeliveryTime),
        alternativeMail: poDetails.alternativeMail || '',
        purchaseOrderNote: poDetails.purchaseOrderNote || '',
        purchaseOrderlines: orderLines.map(line => ({
          ...line,
          pricePerItem: Number(line.pricePerItem),
          amountOfProducts: Number(line.amountOfProducts),
          totalLinePrice: (Number(line.pricePerItem) * Number(line.amountOfProducts)).toFixed(2)
        })),
        taxAmount: taxAmount,
        taxBase: taxBase,
        totalAmount: totalAmount,
        taxPercentage: (taxPercent * 100).toString() + '%'
      }
      PurchaseOrderStoreActions.generatePurchaseOrderPdf(pdfData)
      await this.waitForPdfReady()
      const href = this.state.pdfBlob
      const a = document.createElement('a')
      a.href = href
      a.download = `PO_${poDetails.purchaseOrderNumber}.pdf`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    } catch (e) {
      alert('Kunne ikke generere PDF til download.')
    } finally {
      this.setState({ downloadingPdf: false })
    }
  }

  async onSaveClick() {
    if (this.state.status === STATUS.IS_SAVING) {
      return
    }
    PurchaseOrderStoreActions.savePurchaseOrder()
  }

  render() {
    const suppliers = this.state.suppliers || []
    const poDetails = this.state.purchaseOrderDetails || {}
    const selectedSupplier = poDetails.supplier
    const supplierSearch = poDetails.supplierSearch || ''
    const users = this.state.msbAdminUsers || []
    const orderLines = this.groupOrderLines(poDetails.purchaseOrderlines || [])
    const { newLine } = this.state
    const selectedProduct = (this.state.products || []).find(p => p.elementTitle === newLine.productName)
    const variationOptions = this.getVariationOptions(selectedProduct)
    if (this.state.status === STATUS.REDIRECT) {
      return <Redirect to='/purchase-orders' />
    }
    if (this.state.redirectToSend) {
      return <Redirect to={`/purchase-orders/send/${this.state.redirectToSend}`} />
    }
    if (this.state.status === STATUS.IS_FETCHING) {
      return <FontAwesomeIcon icon='spinner' spin />
    }
    return (
      <React.Fragment>
        {this.state.newPurchaseOrder && (
          <form onSubmit={this.handleSave}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Grid container spacing={2} alignItems='center'>
                  <Grid item xs>
                    <Autocomplete
                      freeSolo
                      options={suppliers}
                      getOptionLabel={option => option.supplierName || ''}
                      inputValue={supplierSearch}
                      loading={this.state.showProductsLoading}
                      onInputChange={(e, value) => {
                        PurchaseOrderStoreActions.updatePurchaseOrderField({ target: { name: 'supplierSearch', value } })
                      }}
                      onChange={(e, value) => {
                        if (value) {
                          this.fetchProducts(value.SupplierID)
                          PurchaseOrderStoreActions.updateSupplier({
                            target: { name: 'supplier', value: value.SupplierID }
                          })
                        } else {
                          PurchaseOrderStoreActions.updateSupplier({
                            target: { name: 'supplier', value: '' }
                          })
                        }
                      }}
                      renderInput={params => <TextField {...params} label='Søg leverandør...' variant='outlined' size='small' />}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        )}

        {selectedSupplier && (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', gap: 32, marginTop: 32, marginBottom: 32 }}>
            <div
              style={{
                width: 1200,
                minHeight: 1123,
                background: '#fff',
                margin: '32px auto',
                boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
                borderRadius: 8,
                padding: '48px 40px 40px 40px',
                fontFamily: 'Segoe UI, Arial, sans-serif',
                fontSize: 15,
                color: '#222',
                position: 'relative'
              }}
            >
              <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
                <h2 style={{ textAlign: 'left', margin: 0, fontSize: '2rem' }}>Indkøbsordre {poDetails.purchaseOrderNumber}</h2>
                {!!poDetails.PurchaseOrderID && (
                  <Button
                    variant='outlined'
                    color='primary'
                    size='small'
                    disabled={isPrepayOrder(poDetails) && !poDetails.prepaidAt}
                    onClick={() =>
                      this.props.history.push({
                        pathname: '/purchase-orders/receive/details',
                        state: { purchaseOrderIDs: [poDetails.PurchaseOrderID] }
                      })
                    }
                  >
                    Gå til varemodtagelse
                  </Button>
                )}
              </Box>
              <Box mb={2}>
                <Typography variant='body1'>
                  <strong>Status:</strong> {purchaseOrderStatusLabel(poDetails.purchaseOrderStatus) || 'Ny'}
                </Typography>
                <Box display='flex' alignItems='center'>
                  <Checkbox
                    color='primary'
                    size='small'
                    checked={isPrepayOrder(poDetails)}
                    disabled={this.isLocked()}
                    onChange={e =>
                      PurchaseOrderStoreActions.updatePurchaseOrderField({
                        target: { name: 'isPrepay', value: e.target.checked }
                      })
                    }
                    style={{ padding: 4, marginLeft: -4 }}
                  />
                  <Typography variant='body1'>Forudbetaling påkrævet</Typography>
                </Box>
                {isPrepayOrder(poDetails) && (
                  <Typography variant='body2'>
                    {poDetails.prepaidAt
                      ? `Betalt ${new Date(poDetails.prepaidAt).toLocaleString('da-DK')}`
                      : 'Ordren er ikke bekræftet som på vej, før hele forudbetalingen er registreret.'}
                  </Typography>
                )}
                {canMarkPurchaseOrderPaid(poDetails) && (
                  <Button
                    variant='contained'
                    color='primary'
                    disabled={!!this.state.payingPurchaseOrderID}
                    onClick={() => {
                      if (window.confirm('Bekræft, at hele indkøbsordren er betalt. Ordren flyttes til På vej.')) {
                        PurchaseOrderStoreActions.markPurchaseOrderPaid(poDetails)
                      }
                    }}
                  >
                    Markér som betalt
                  </Button>
                )}
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    label='Dato'
                    type='date'
                    value={this.formatDate(poDetails.dateCreated) || ''}
                    InputLabelProps={{ shrink: true }}
                    size='small'
                    disabled={this.isLocked()}
                    onChange={e =>
                      PurchaseOrderStoreActions.updatePurchaseOrderField({
                        target: { name: 'dateCreated', value: e.target.value }
                      })
                    }
                    style={{ marginBottom: 8, width: '100%' }}
                  />
                  <FormControl style={{ marginBottom: 8, width: '100%' }} disabled={this.isLocked()}>
                    <InputLabel>Ordretype</InputLabel>
                    <Select
                      name='orderType'
                      value={poDetails.isDropShip ? 'Dropship' : poDetails.orderType || 'Almindelig'}
                      onChange={e => {
                        this.updatePurchaseOrderType(e)
                      }}
                      size='small'
                    >
                      <MenuItem value='Almindelig'>Almindelig</MenuItem>
                      <MenuItem value='Dropship'>Dropship</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6} style={{ textAlign: 'right' }}>
                  <FormControl style={{ minWidth: 100, marginBottom: 8, marginLeft: 16 }} disabled={this.isLocked()}>
                    <InputLabel>Valuta</InputLabel>
                    <Select
                      name='currency'
                      value={poDetails.currency || 'DKK'}
                      onChange={PurchaseOrderStoreActions.updatePurchaseOrderField}
                      size='small'
                    >
                      {this.state.currencies.map(cur => (
                        <MenuItem key={cur.value} value={cur.value}>
                          {cur.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <div>
                    <strong>Leverandør</strong>
                    <div style={{ fontSize: 14, marginTop: 8 }}>
                      {selectedSupplier.supplierName || ''}
                      <br />
                      CVR: {selectedSupplier.corporateIdentificationNumber || ''}
                      <br />
                      Email: {selectedSupplier.email || ''}
                      <br />
                      Addresse: {selectedSupplier.address || ''}
                    </div>
                  </div>
                  {selectedSupplier?.isDropship ? (
                    <div style={{ marginTop: 16 }}>
                      <strong>Leveringsadresse</strong>
                      <br />
                      <span>Se nedenfor</span>
                    </div>
                  ) : (
                    <div style={{ marginTop: 16 }}>
                      <strong>Leveringsadresse</strong>
                      <br />
                      {[1, 2, 3, 4, 5].map(i => (
                        <TextField
                          key={i}
                          name={`deliveryAddress${i}`}
                          label={`Adresse ${i}`}
                          defaultValue={['Upgrader A/S', 'Ellekær 6', '2730 Herlev', 'Danmark', ''][i - 1]}
                          size='small'
                          disabled={this.isLocked()}
                          style={{ marginBottom: 4, width: '100%' }}
                          onChange={PurchaseOrderStoreActions.updatePurchaseOrderField}
                        />
                      ))}
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl style={{ width: '100%', marginBottom: 8 }} disabled={this.isLocked()}>
                    <InputLabel>Indkøber</InputLabel>
                    <Select name='purchaser' value={poDetails.buyerUserID || ''} onChange={PurchaseOrderStoreActions.updateOurRef} size='small'>
                      <MenuItem value=''>
                        <em>Vælg indkøber</em>
                      </MenuItem>
                      {users.map(user => (
                        <MenuItem key={user.UserID} value={user.UserID}>
                          {user.userName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    label='Vores ref.'
                    value={poDetails.ourRef || ''}
                    size='small'
                    disabled={this.isLocked()}
                    style={{ marginBottom: 8, width: '100%' }}
                    onChange={PurchaseOrderStoreActions.updatePurchaseOrderField}
                  />
                  <TextField
                    label='Deres ref.'
                    name='theirRef'
                    value={poDetails.theirRef || ''}
                    size='small'
                    disabled={this.isLocked()}
                    style={{ marginBottom: 8, width: '100%' }}
                    onChange={PurchaseOrderStoreActions.updatePurchaseOrderField}
                  />
                  <TextField
                    label='Leveringsdato'
                    type='date'
                    size='small'
                    value={this.formatDate(poDetails.alternativeDeliveryTime) || ''}
                    name='alternativeDeliveryTime'
                    disabled={this.isLocked()}
                    style={{ marginBottom: 8, width: '100%' }}
                    InputLabelProps={{ shrink: true }}
                    onChange={PurchaseOrderStoreActions.updatePurchaseOrderField}
                  />
                  <TextField
                    label='Alternativ Mail'
                    type='text'
                    name='alternativeMail'
                    value={poDetails.alternativeMail || ''}
                    size='small'
                    disabled={this.isLocked()}
                    style={{ marginBottom: 8, width: '100%' }}
                    InputLabelProps={{ shrink: true }}
                    onChange={PurchaseOrderStoreActions.updatePurchaseOrderField}
                  />
                  <TextField
                    label='Note'
                    type='text'
                    name='purchaseOrderNote'
                    value={poDetails.purchaseOrderNote || ''}
                    size='small'
                    disabled={this.isLocked()}
                    style={{ marginBottom: 8, width: '100%' }}
                    InputLabelProps={{ shrink: true }}
                    onChange={PurchaseOrderStoreActions.updatePurchaseOrderField}
                  />
                </Grid>
              </Grid>
              <h5 style={{ marginTop: 32, marginBottom: 16 }}>Ordrelinjer</h5>
              <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap='wrap' gridGap={12} mb={2}>
                {this.state.selectedLineIndices.length > 0 ? (
                  <Typography variant='body2' color='textSecondary'>
                    {this.state.selectedLineIndices.length} linje(r) valgt
                  </Typography>
                ) : (
                  <span />
                )}
                <Box display='flex' gridGap={8}>
                  <Button
                    variant='outlined'
                    size='small'
                    disabled={this.state.selectedLineIndices.length === 0}
                    onClick={() =>
                      this.setState({
                        orderLineTypeDialogOpen: true,
                        orderLineTypeDialogIdx: null,
                        orderLineTypeDialogIndices: [...this.state.selectedLineIndices],
                        orderLineTypeDialogType: '',
                        orderLineTypeDialogNote: ''
                      })
                    }
                  >
                    Vælg type
                  </Button>
                  <Button
                    variant='outlined'
                    color='secondary'
                    size='small'
                    disabled={this.state.selectedLineIndices.length === 0}
                    startIcon={<ReportProblemIcon />}
                    onClick={this.openMarkErrorDialog}
                  >
                    Marker fejl
                  </Button>
                </Box>
              </Box>
              {!this.allLinesHaveType() && (
                <Box
                  display='flex'
                  alignItems='center'
                  gridGap={8}
                  mb={2}
                  p={1.5}
                  style={{ background: '#fdecea', border: '1px solid #f5c6cb', borderRadius: 6 }}
                >
                  <ReportProblemIcon fontSize='small' style={{ color: '#d32f2f' }} />
                  <Typography variant='body2' style={{ color: '#d32f2f' }}>
                    Manglende ordretype på en eller flere linjer
                  </Typography>
                </Box>
              )}
              <form onSubmit={this.handleAddLine} style={{ marginBottom: 20 }}>
                <Grid container spacing={1} alignItems='flex-end' style={{ flexWrap: 'nowrap' }}>
                  <Grid item style={{ minWidth: 220 }}>
                    <Autocomplete
                      options={this.getProductOptions()}
                      getOptionLabel={option => option.label || ''}
                      filterOptions={(options, { inputValue }) =>
                        options.filter(
                          option =>
                            option.elementTitle?.toLowerCase().includes(inputValue.toLowerCase()) || String(option.ProductID).includes(inputValue)
                        )
                      }
                      value={this.getProductOptions().find(p => p.elementTitle === newLine.productName) || null}
                      onChange={(e, value) => {
                        let variationID = ''
                        let variationUID = ''
                        let description = value ? value.elementTitle : ''
                        let pricePerItem = value ? Number(value.productPrice) : 0
                        let colli = value ? Number(value.colli) || 0 : 0
                        if (value && value.variations && value.variations.length === 1) {
                          variationID = value.variations[0].VariationID
                          variationUID = value.variations[0].variationUID
                          if (!this.state.newLine.descriptionTouched) {
                            description = `${value.elementTitle}, ${value.variations[0].variationTitle}`
                          }
                        } else {
                          if (!this.state.newLine.descriptionTouched) {
                            description = value ? value.elementTitle : ''
                          }
                        }
                        this.setState({
                          newLine: {
                            ...newLine,
                            productName: value ? value.elementTitle : '',
                            productVariationID: variationID,
                            productVariationUID: variationUID,
                            description: this.state.newLine.descriptionTouched ? newLine.description : description,
                            pricePerItem,
                            colli
                          }
                        })
                      }}
                      renderInput={params => <TextField {...params} label='Produkt' variant='outlined' size='small' />}
                    />
                  </Grid>
                  <Grid item style={{ minWidth: 160 }}>
                    <Autocomplete
                      options={variationOptions}
                      getOptionLabel={option => option.label || ''}
                      value={variationOptions.find(v => v.variationUID === newLine.productVariationUID) || null}
                      onChange={(e, value) => {
                        this.setState({
                          newLine: {
                            ...newLine,
                            productVariationID: value ? value.VariationID : '',
                            productVariationUID: value ? value.variationUID : '',
                            description: this.state.newLine.descriptionTouched
                              ? newLine.description
                              : selectedProduct && value
                              ? `${selectedProduct.elementTitle}, ${value.variationTitle}`
                              : newLine.description,
                            colli: value ? this.getColliForVariation(value.VariationID) : 0
                          }
                        })
                      }}
                      renderInput={params => <TextField {...params} label='Variant' variant='outlined' size='small' />}
                      disabled={!selectedProduct}
                    />
                  </Grid>
                  <Grid item style={{ minWidth: 220 }}>
                    <TextField
                      name='description'
                      label='Beskrivelse'
                      multiline
                      rows={2}
                      size='small'
                      style={{ width: '100%', fontSize: 'small' }}
                      value={newLine.description || ''}
                      onChange={this.handleLineFieldChange}
                    />
                  </Grid>
                  <Grid item style={{ minWidth: 60 }}>
                    <TextField
                      name='amountOfProducts'
                      label='Antal'
                      type='number'
                      size='small'
                      value={newLine.amountOfProducts || 1}
                      onChange={this.handleLineFieldChange}
                      inputProps={{ min: 1 }}
                    />
                  </Grid>
                  <Grid item style={{ minWidth: 90 }}>
                    <TextField
                      name='pricePerItem'
                      label='Pris'
                      type='text'
                      size='small'
                      value={newLine.pricePerItem || 0}
                      onChange={this.handleLineFieldChange}
                      inputProps={{ min: 0 }}
                    />
                  </Grid>
                  <Grid item>
                    <Button variant='contained' color='primary' size='small' type='submit' style={{ minWidth: 70 }}>
                      Tilføj
                    </Button>
                  </Grid>
                </Grid>
              </form>
              <Paper style={{ overflowX: 'auto', marginBottom: 24, boxShadow: 'none', borderRadius: 6, border: '1px solid #e0e0e0' }}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell padding='none' style={{ width: 28, background: '#f6f8fa', textAlign: 'center' }} />
                      <TableCell style={{ width: 90, background: '#f6f8fa', fontWeight: 600 }}>Varenr.</TableCell>
                      <TableCell style={{ width: 240, background: '#f6f8fa', fontWeight: 600 }}>Beskrivelse</TableCell>
                      <TableCell style={{ width: 60, background: '#f6f8fa', fontWeight: 600 }}>Antal</TableCell>
                      <TableCell style={{ width: 70, background: '#f6f8fa', fontWeight: 600 }}>Colli</TableCell>
                      <TableCell style={{ width: 90, background: '#f6f8fa', fontWeight: 600 }}>Pris</TableCell>
                      <TableCell style={{ width: 110, background: '#f6f8fa', fontWeight: 600 }}>Beløb</TableCell>
                      {poDetails.purchaseOrderStatus !== 'NEW' && (
                        <TableCell style={{ width: 90, background: '#f6f8fa', fontWeight: 600 }}>Modtaget</TableCell>
                      )}
                      <TableCell style={{ width: 80, background: '#f6f8fa', fontWeight: 600 }}>Type</TableCell>
                      <TableCell style={{ width: 60, background: '#f6f8fa' }}></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.groupOrderLines(poDetails.purchaseOrderlines || []).map(line => {
                      const groupKey = `${line.productVariationID}||${line.description}`
                      const isExpanded = this.state.expandedGroupKey === groupKey
                      const groupLines = (poDetails.purchaseOrderlines || [])
                        .map((l, i) => ({ ...l, _idx: i }))
                        .filter(l => l.productVariationID === line.productVariationID && l.description === line.description)

                      const groupIndices = groupLines.map(gl => gl._idx)
                      const allSelected = groupIndices.every(i => this.state.selectedLineIndices.includes(i))
                      const someSelected = !allSelected && groupIndices.some(i => this.state.selectedLineIndices.includes(i))
                      const toggleGroupSelection = () => {
                        if (allSelected) {
                          this.setState({ selectedLineIndices: this.state.selectedLineIndices.filter(i => !groupIndices.includes(i)) })
                        } else {
                          this.setState({ selectedLineIndices: Array.from(new Set([...this.state.selectedLineIndices, ...groupIndices])) })
                        }
                      }
                      const isEditingSingle = this.state.editingLineIndex === groupLines[0]?._idx && groupLines.length === 1
                      const colli = Number(line.colli) || 0
                      const isMismatch = colli > 0 && Number(line.amountOfProducts) % colli !== 0
                      const warnStyle = isMismatch ? { color: '#d32f2f', fontWeight: 600 } : undefined

                      return (
                        <React.Fragment key={groupKey}>
                          <TableRow>
                            <TableCell padding='none' style={{ width: 28, textAlign: 'center' }}>
                              <Checkbox
                                color='primary'
                                size='small'
                                indeterminate={someSelected}
                                checked={allSelected}
                                onChange={toggleGroupSelection}
                                style={{ padding: 0 }}
                              />
                            </TableCell>
                            <TableCell>{line.productVariationUID}</TableCell>
                            <TableCell>
                              {isEditingSingle ? (
                                <TextField
                                  value={this.state.editLineData.description}
                                  onChange={e => this.setState({ editLineData: { ...this.state.editLineData, description: e.target.value } })}
                                  size='small'
                                  multiline
                                  rows={2}
                                  style={{ width: '100%' }}
                                  inputProps={{ style: { fontSize: 12, lineHeight: '1.3em' } }}
                                />
                              ) : (
                                <pre
                                  style={{
                                    margin: 0,
                                    fontFamily: 'inherit',
                                    whiteSpace: 'pre-wrap',
                                    background: 'none',
                                    border: 'none',
                                    fontSize: 'small'
                                  }}
                                >
                                  {line.description}
                                </pre>
                              )}
                            </TableCell>
                            <TableCell style={warnStyle}>
                              {isEditingSingle ? (
                                <TextField
                                  type='number'
                                  size='small'
                                  value={this.state.editLineData.amountOfProducts}
                                  onChange={e => this.setState({ editLineData: { ...this.state.editLineData, amountOfProducts: e.target.value } })}
                                  inputProps={{ min: 1 }}
                                  style={{ width: 60 }}
                                />
                              ) : (
                                line.amountOfProducts
                              )}
                            </TableCell>
                            <TableCell style={warnStyle}>{colli || '-'}</TableCell>
                            <TableCell>
                              {isEditingSingle ? (
                                <TextField
                                  type='text'
                                  size='small'
                                  value={this.state.editLineData.pricePerItem}
                                  onChange={e =>
                                    this.setState({ editLineData: { ...this.state.editLineData, pricePerItem: e.target.value.replace(',', '.') } })
                                  }
                                  style={{ width: 90 }}
                                />
                              ) : (
                                Number(line.pricePerItem).toLocaleString('da-DK', { minimumFractionDigits: 2 })
                              )}
                            </TableCell>
                            <TableCell>
                              {isEditingSingle
                                ? (this.state.editLineData.amountOfProducts * this.state.editLineData.pricePerItem).toLocaleString('da-DK', {
                                    minimumFractionDigits: 2
                                  })
                                : (line.amountOfProducts * line.pricePerItem).toLocaleString('da-DK', { minimumFractionDigits: 2 })}
                            </TableCell>
                            {poDetails.purchaseOrderStatus !== 'NEW' && (
                              <TableCell>
                                {(() => {
                                  const received = Number(line.amountReceived) || 0
                                  const expected = Number(line.amountOfProducts) || 0
                                  const color = received === 0 ? '#d32f2f' : received < expected ? '#ed6c02' : '#2e7d32'
                                  return (
                                    <span style={{ color, fontWeight: 600 }}>
                                      {received}/{expected}
                                    </span>
                                  )
                                })()}
                              </TableCell>
                            )}
                            <TableCell>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                {groupLines.length === 1 &&
                                  !isExpanded &&
                                  (() => {
                                    switch (groupLines[0].orderLineType) {
                                      case 'ORDER':
                                        return <ListAltIcon fontSize='small' titleAccess='Order' />
                                      case 'STAFFPURCHASE':
                                        return <PersonIcon fontSize='small' titleAccess='Staff Purchase' />
                                      case 'WAREHOUSE':
                                        return <HouseIcon fontSize='small' titleAccess='To Warehouse' />
                                      default:
                                        return null
                                    }
                                  })()}
                                {groupLines.some(l => l.purchaseOrderLineNote) && (
                                  <ReportProblemIcon
                                    fontSize='small'
                                    style={{ color: '#ed6c02' }}
                                    titleAccess={groupLines.find(l => l.purchaseOrderLineNote)?.purchaseOrderLineNote}
                                  />
                                )}
                              </div>
                            </TableCell>
                            <TableCell>
                              {isEditingSingle ? (
                                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                                  <IconButton
                                    color='primary'
                                    size='small'
                                    onClick={() => {
                                      const updatedLines = [...poDetails.purchaseOrderlines]
                                      const idx = groupLines[0]._idx
                                      const { amountOfProducts, ...rest } = this.state.editLineData
                                      const amount = Number(amountOfProducts)
                                      if (amount > 1) {
                                        updatedLines.splice(idx, 1)
                                        for (let i = 0; i < amount; i++) {
                                          updatedLines.splice(
                                            idx + i,
                                            0,
                                            i === 0
                                              ? { ...rest, amountOfProducts: 1 }
                                              : { ...rest, amountOfProducts: 1, orderID: null, orderLineID: null, orderLineType: '' }
                                          )
                                        }
                                      } else {
                                        updatedLines[idx] = { ...updatedLines[idx], ...this.state.editLineData }
                                      }
                                      PurchaseOrderStoreActions.updatePurchaseOrderField({
                                        target: { name: 'purchaseOrderlines', value: updatedLines }
                                      })
                                      this.setState({ editingLineIndex: null, editLineData: null })
                                    }}
                                  >
                                    <CheckIcon />
                                  </IconButton>
                                  <IconButton size='small' onClick={() => this.setState({ editingLineIndex: null, editLineData: null })}>
                                    <CloseIcon />
                                  </IconButton>
                                  <IconButton color='primary' size='small' title='Order' onClick={() => {}}>
                                    <AssignmentIcon />
                                  </IconButton>
                                </div>
                              ) : isExpanded ? (
                                <IconButton size='small' onClick={() => this.setState({ expandedGroupKey: null, editGroupData: null })}>
                                  <CloseIcon />
                                </IconButton>
                              ) : (
                                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                                  {groupLines.length === 1 && (
                                    <IconButton
                                      color='primary'
                                      size='small'
                                      disabled={groupLines[0].orderLineID}
                                      title='Order'
                                      onClick={() =>
                                        this.setState({
                                          orderLineTypeDialogOpen: true,
                                          orderLineTypeDialogIdx: groupLines[0]._idx,
                                          orderLineTypeDialogType: null,
                                          orderLineTypeDialogNote: ''
                                        })
                                      }
                                    >
                                      <AssignmentIcon />
                                    </IconButton>
                                  )}
                                  <IconButton
                                    color='default'
                                    size='small'
                                    title='Rediger'
                                    onClick={() => {
                                      if (groupLines.length > 1) {
                                        this.setState({ expandedGroupKey: groupKey, editGroupData: groupLines.map(l => ({ ...l })) })
                                      } else {
                                        this.setState({ editingLineIndex: groupLines[0]._idx, editLineData: { ...groupLines[0] } })
                                      }
                                    }}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                  <IconButton
                                    color='secondary'
                                    size='small'
                                    title='Slet gruppe'
                                    onClick={() => {
                                      const updatedLines = (poDetails.purchaseOrderlines || []).filter(
                                        l => !(l.productVariationID === line.productVariationID && l.description === line.description)
                                      )
                                      PurchaseOrderStoreActions.updatePurchaseOrderField({
                                        target: { name: 'purchaseOrderlines', value: updatedLines }
                                      })
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </div>
                              )}
                            </TableCell>
                          </TableRow>

                          {isExpanded && (
                            <>
                              <TableRow style={{ background: '#f9f9f9' }}>
                                <TableCell padding='none' style={{ width: 28 }} />
                                <TableCell colSpan={2} style={{ fontStyle: 'italic' }}></TableCell>
                                <TableCell>
                                  <TextField
                                    type='number'
                                    size='small'
                                    value={this.state.editGroupAmount ?? groupLines.length}
                                    onChange={e => this.setState({ editGroupAmount: Number(e.target.value) })}
                                    inputProps={{ min: 1 }}
                                    style={{ width: 60 }}
                                  />
                                </TableCell>
                                <TableCell />
                                <TableCell />
                                <TableCell>
                                  <TextField
                                    type='text'
                                    size='small'
                                    value={this.state.editGroupPrice ?? groupLines[0].pricePerItem}
                                    onChange={e => this.setState({ editGroupPrice: e.target.value.replace(',', '.') })}
                                    style={{ width: 90 }}
                                  />
                                </TableCell>
                                <TableCell colSpan={2}>
                                  <Button
                                    color='primary'
                                    size='small'
                                    onClick={() => {
                                      const amount = Number(this.state.editGroupAmount ?? groupLines.length)
                                      const price = this.state.editGroupPrice ?? groupLines[0].pricePerItem
                                      const currrentLines = [...poDetails.purchaseOrderlines]
                                      const linesForVariation = currrentLines.filter(
                                        l => l.productVariationID === line.productVariationID && l.description === line.description
                                      )
                                      const updatedLines = currrentLines.filter(
                                        l => !(l.productVariationID === line.productVariationID && l.description === line.description)
                                      )
                                      for (let i = 0; i < amount; i++) {
                                        if (i < linesForVariation.length) {
                                          updatedLines.push({ ...linesForVariation[i], pricePerItem: price })
                                        } else {
                                          updatedLines.push({
                                            ...groupLines[0],
                                            pricePerItem: price,
                                            amountOfProducts: 1,
                                            orderID: null,
                                            orderLineID: null,
                                            orderLineType: ''
                                          })
                                        }
                                      }
                                      PurchaseOrderStoreActions.updatePurchaseOrderField({
                                        target: { name: 'purchaseOrderlines', value: updatedLines }
                                      })
                                      this.setState({ expandedGroupKey: null, editGroupData: null, editGroupAmount: null, editGroupPrice: null })
                                    }}
                                    style={{ minWidth: 70 }}
                                  >
                                    Gem
                                  </Button>
                                  <Button
                                    size='small'
                                    onClick={() =>
                                      this.setState({ expandedGroupKey: null, editGroupData: null, editGroupAmount: null, editGroupPrice: null })
                                    }
                                    style={{ minWidth: 70 }}
                                  >
                                    Annuller
                                  </Button>
                                </TableCell>
                              </TableRow>
                              {groupLines.map((entry, entryIdx) => (
                                <TableRow key={entry._idx} style={{ background: '#f9f9f9' }}>
                                  <TableCell padding='none' style={{ width: 28, textAlign: 'center' }}>
                                    <Checkbox
                                      color='primary'
                                      size='small'
                                      checked={this.state.selectedLineIndices.includes(entry._idx)}
                                      onChange={() => {
                                        const sel = new Set(this.state.selectedLineIndices)
                                        if (sel.has(entry._idx)) sel.delete(entry._idx)
                                        else sel.add(entry._idx)
                                        this.setState({ selectedLineIndices: Array.from(sel) })
                                      }}
                                      style={{ padding: 0 }}
                                    />
                                  </TableCell>
                                  <TableCell colSpan={1} style={{ fontStyle: 'italic' }}>
                                    {entry.productVariationID}
                                  </TableCell>
                                  <TableCell colSpan={2}>
                                    <TextField
                                      size='small'
                                      value={this.state.editGroupData?.[entryIdx]?.description ?? entry.description}
                                      onChange={e => {
                                        const editGroupData = this.state.editGroupData
                                          ? [...this.state.editGroupData]
                                          : groupLines.map(l => ({ ...l }))
                                        editGroupData[entryIdx].description = e.target.value
                                        this.setState({ editGroupData })
                                      }}
                                      style={{ width: '100%' }}
                                      multiline
                                      rows={2}
                                      inputProps={{ style: { fontSize: 12, lineHeight: '1.3em' } }}
                                    />
                                  </TableCell>
                                  <TableCell colSpan={2}>
                                    {(() => {
                                      switch (entry.orderLineType) {
                                        case 'ORDER':
                                          return <ListAltIcon fontSize='small' titleAccess='Order' />
                                        case 'STAFFPURCHASE':
                                          return <PersonIcon fontSize='small' titleAccess='Staff Purchase' />
                                        case 'WAREHOUSE':
                                          return <HouseIcon fontSize='small' titleAccess='To Warehouse' />
                                        default:
                                          return null
                                      }
                                    })()}
                                  </TableCell>
                                  <TableCell colSpan={3} style={{ textAlign: 'right' }}>
                                    <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                                      <IconButton
                                        color='primary'
                                        size='small'
                                        disabled={entry.orderLineID}
                                        title='Order'
                                        onClick={() =>
                                          this.setState({
                                            orderLineTypeDialogOpen: true,
                                            orderLineTypeDialogIdx: entry._idx,
                                            orderLineTypeDialogType: null,
                                            orderLineTypeDialogNote: ''
                                          })
                                        }
                                      >
                                        <AssignmentIcon />
                                      </IconButton>
                                      <IconButton
                                        color='primary'
                                        size='small'
                                        title='Gem'
                                        onClick={() => {
                                          const updatedLines = [...poDetails.purchaseOrderlines]
                                          updatedLines[entry._idx] = {
                                            ...updatedLines[entry._idx],
                                            description: this.state.editGroupData?.[entryIdx]?.description ?? entry.description
                                          }
                                          PurchaseOrderStoreActions.updatePurchaseOrderField({
                                            target: { name: 'purchaseOrderlines', value: updatedLines }
                                          })
                                          this.setState({ expandedGroupKey: null, editGroupData: null, editGroupAmount: null, editGroupPrice: null })
                                        }}
                                      >
                                        <CheckIcon />
                                      </IconButton>
                                      <IconButton
                                        size='small'
                                        title='Annuller'
                                        onClick={() => this.setState({ expandedGroupKey: null, editGroupData: null })}
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                      <IconButton
                                        color='secondary'
                                        size='small'
                                        title='Slet linje'
                                        onClick={() => {
                                          const updatedLines = [...poDetails.purchaseOrderlines]
                                          updatedLines.splice(entry._idx, 1)
                                          PurchaseOrderStoreActions.updatePurchaseOrderField({
                                            target: { name: 'purchaseOrderlines', value: updatedLines }
                                          })
                                          this.setState({ expandedGroupKey: null, editGroupData: null })
                                        }}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </>
                          )}
                        </React.Fragment>
                      )
                    })}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TableCell
                        colSpan={poDetails.purchaseOrderStatus !== 'NEW' ? 8 : 7}
                        style={{ textAlign: 'right', background: '#f6f8fa', fontWeight: 600 }}
                      >
                        Total
                      </TableCell>
                      <TableCell colSpan={2} style={{ background: '#f6f8fa', fontWeight: 600 }}>
                        {orderLines
                          .reduce((sum, l) => sum + l.amountOfProducts * l.pricePerItem, 0)
                          .toLocaleString('da-DK', { minimumFractionDigits: 2 })}{' '}
                        {poDetails.currency || 'DKK'}
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                </Table>
              </Paper>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginBottom: 16 }}>
                <Button
                  variant='contained'
                  color='primary'
                  size='small'
                  disabled={!this.allLinesHaveType() || this.state.status === STATUS.IS_SAVING}
                  onClick={this.onSaveClick.bind(this)}
                >
                  Gem indkøbsordre
                </Button>
                {poDetails.purchaseOrderStatus === 'NEW' ? (
                  <Button
                    variant='contained'
                    color='primary'
                    size='small'
                    disabled={!this.allLinesHaveType()}
                    onClick={() => this.getDataForPDFGeneration()}
                  >
                    Godkend
                  </Button>
                ) : (
                  <Button variant='contained' color='primary' size='small' onClick={this.handleDownloadPdf} disabled={this.state.downloadingPdf}>
                    Download PDF
                  </Button>
                )}
              </div>
            </div>
            <Box display={'flex'} flexDirection={'column'} gridGap={24}>
              <Paper elevation={2} style={{ width: 320, padding: 24, borderRadius: 8, flexShrink: 0 }}>
                <Typography variant='h6' gutterBottom>
                  Leverandørinfo
                </Typography>
                <Divider style={{ marginBottom: 16 }} />
                <Typography variant='body1' gutterBottom>
                  <strong>Navn:</strong> {selectedSupplier.supplierName || '-'}
                </Typography>
                <Typography variant='body1' gutterBottom>
                  <strong>CVR:</strong> {selectedSupplier.supplierUID || '-'}
                </Typography>
                <Typography variant='body1' gutterBottom>
                  <strong>Email:</strong> {selectedSupplier.email || '-'}
                </Typography>
                <Typography variant='body1' gutterBottom>
                  <strong>Adresse:</strong> {selectedSupplier.address || '-'}
                </Typography>
                <Typography variant='body1' gutterBottom>
                  <strong>Type:</strong> {selectedSupplier.isDropship ? 'Dropship' : 'Almindelig'}
                </Typography>
                {selectedSupplier.accesses && selectedSupplier.accesses.length > 0 && (
                  <Box mt={2} mb={2} p={2} bgcolor='#f6f8fa' borderRadius={4} border='1px solid #e0e0e0'>
                    <Typography variant='body1' gutterBottom>
                      <strong>Login:</strong>
                    </Typography>
                    <Box display='flex' alignItems='center' mb={1}>
                      <Typography variant='body2' style={{ minWidth: 60 }}>
                        URL:
                      </Typography>
                      <Typography variant='body2' style={{ wordBreak: 'break-all', flex: 1 }}>
                        {selectedSupplier.accesses[0].url || '-'}
                      </Typography>
                      <IconButton
                        size='small'
                        onClick={() => navigator.clipboard.writeText(selectedSupplier.accesses[0].url || '')}
                        title='Kopier URL'
                      >
                        <AssignmentIcon fontSize='small' />
                      </IconButton>
                    </Box>
                    <Box display='flex' alignItems='center' mb={1}>
                      <Typography variant='body2' style={{ minWidth: 60 }}>
                        Brugernavn:
                      </Typography>
                      <Typography variant='body2' style={{ wordBreak: 'break-all', flex: 1 }}>
                        {selectedSupplier.accesses[0].username || '-'}
                      </Typography>
                      <IconButton
                        size='small'
                        onClick={() => navigator.clipboard.writeText(selectedSupplier.accesses[0].username || '')}
                        title='Kopier brugernavn'
                      >
                        <AssignmentIcon fontSize='small' />
                      </IconButton>
                    </Box>
                    <Box display='flex' alignItems='center'>
                      <Typography variant='body2' style={{ minWidth: 60 }}>
                        Kodeord:
                      </Typography>
                      <TextField
                        value={selectedSupplier.accesses[0].password || ''}
                        type={this.state.showPassword ? 'text' : 'password'}
                        size='small'
                        InputProps={{ readOnly: true }}
                        style={{ flex: 1, marginRight: 8 }}
                      />
                      <IconButton
                        size='small'
                        onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                        title={this.state.showPassword ? 'Skjul kodeord' : 'Vis kodeord'}
                      >
                        {this.state.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                      </IconButton>
                      <IconButton
                        size='small'
                        onClick={() => navigator.clipboard.writeText(selectedSupplier.accesses[0].password || '')}
                        title='Kopier kodeord'
                      >
                        <AssignmentIcon fontSize='small' />
                      </IconButton>
                    </Box>
                  </Box>
                )}
              </Paper>
              {!!this.state.purchaseOrderDetails.PurchaseOrderID && (
                <Paper style={{ width: 320, padding: 24, borderRadius: 8, flexShrink: 0 }}>
                  <CommentSection relatedType='PurchaseOrder' relatedID={this.state.purchaseOrderDetails.PurchaseOrderID} />
                </Paper>
              )}
            </Box>
          </div>
        )}
        <Dialog
          open={this.state.orderLineTypeDialogOpen}
          onClose={() => this.setState({ orderLineTypeDialogOpen: false, orderLineTypeDialogIdx: null, orderLineTypeDialogIndices: [] })}
        >
          <DialogTitle>Vælg ordretype</DialogTitle>
          <DialogContent>
            <Button
              variant='contained'
              color='primary'
              style={{ marginBottom: 12, width: 200 }}
              onClick={() => this.setState({ orderLineTypeDialogType: 'ORDER' })}
            >
              Order
            </Button>
            <br />
            <Button
              variant='contained'
              color='secondary'
              style={{ marginBottom: 12, width: 200 }}
              onClick={() => this.setState({ orderLineTypeDialogType: 'STAFFPURCHASE' })}
            >
              Staff Purchase
            </Button>
            <br />
            <Button variant='contained' style={{ width: 200 }} onClick={() => this.setState({ orderLineTypeDialogType: 'WAREHOUSE' })}>
              To Warehouse
            </Button>
            <br />
            {this.state.orderLineTypeDialogType === 'STAFFPURCHASE' && (
              <TextField
                label='Note (påkrævet)'
                value={this.state.orderLineTypeDialogNote}
                onChange={e => this.setState({ orderLineTypeDialogNote: e.target.value })}
                required
                fullWidth
                margin='normal'
              />
            )}
            {this.state.orderLineTypeDialogType === 'WAREHOUSE' && (
              <TextField
                label='Note (valgfri)'
                value={this.state.orderLineTypeDialogNote}
                onChange={e => this.setState({ orderLineTypeDialogNote: e.target.value })}
                fullWidth
                margin='normal'
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                const idx = this.state.orderLineTypeDialogIdx
                const indices = this.state.orderLineTypeDialogIndices || []
                const poDetails = this.state.purchaseOrderDetails
                const updatedLines = [...(poDetails.purchaseOrderlines || [])]
                const update = {
                  orderLineType: this.state.orderLineTypeDialogType,
                  purchaseOrderLineNote:
                    this.state.orderLineTypeDialogType === 'STAFFPURCHASE' || this.state.orderLineTypeDialogType === 'WAREHOUSE'
                      ? this.state.orderLineTypeDialogNote
                      : ''
                }
                if (indices.length > 0 && (idx === null || idx === undefined)) {
                  indices.forEach(i => {
                    updatedLines[i] = { ...updatedLines[i], ...update }
                  })
                } else if (idx !== null && idx !== undefined) {
                  updatedLines[idx] = { ...updatedLines[idx], ...update }
                }
                PurchaseOrderStoreActions.updatePurchaseOrderField({ target: { name: 'purchaseOrderlines', value: updatedLines } })
                this.setState({
                  orderLineTypeDialogOpen: false,
                  orderLineTypeDialogIdx: null,
                  orderLineTypeDialogIndices: [],
                  orderLineTypeDialogType: null,
                  orderLineTypeDialogNote: '',
                  selectedLineIndices: []
                })
              }}
              color='primary'
              disabled={this.state.orderLineTypeDialogType === 'STAFFPURCHASE' && !this.state.orderLineTypeDialogNote}
            >
              Gem
            </Button>
            <Button onClick={() => this.setState({ orderLineTypeDialogOpen: false, orderLineTypeDialogIdx: null, orderLineTypeDialogIndices: [] })}>
              Luk
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.markErrorDialogOpen}
          onClose={this.closeMarkErrorDialog}
          maxWidth='sm'
          fullWidth
          PaperProps={{ style: { borderRadius: 10 } }}
        >
          {this.state.markErrorStep === 'select' && (
            <>
              <DialogTitle style={{ paddingBottom: 0 }}>
                Marker fejl på valgte linjer
                <Typography variant='body2' color='textSecondary'>
                  {this.state.selectedLineIndices.length} linje(r) valgt
                </Typography>
              </DialogTitle>
              <DialogContent>
                <Typography variant='body2' color='textSecondary' style={{ marginBottom: 16 }}>
                  Vælg hvad der er galt med varen. Berørte kunder foreslås automatisk informeret via mail/SMS.
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Paper
                      variant='outlined'
                      onClick={() => this.setState({ markErrorType: 'RESTORDRE' })}
                      style={{
                        padding: 20,
                        cursor: 'pointer',
                        textAlign: 'center',
                        position: 'relative',
                        borderWidth: 2,
                        borderColor: this.state.markErrorType === 'RESTORDRE' ? '#1976d2' : '#e0e0e0',
                        background: this.state.markErrorType === 'RESTORDRE' ? '#e8f2fc' : '#fff'
                      }}
                    >
                      {this.state.markErrorType === 'RESTORDRE' && (
                        <CheckCircleIcon fontSize='small' style={{ position: 'absolute', top: 8, right: 8, color: '#1976d2' }} />
                      )}
                      <HourglassEmptyIcon style={{ fontSize: 32, color: '#ed6c02', marginBottom: 8 }} />
                      <Typography variant='subtitle2' style={{ fontWeight: 700 }}>
                        Restordre
                      </Typography>
                      <Typography variant='caption' color='textSecondary'>
                        Ude af lager hos leverandør
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={6}>
                    <Paper
                      variant='outlined'
                      onClick={() => this.setState({ markErrorType: 'UDGAAET' })}
                      style={{
                        padding: 20,
                        cursor: 'pointer',
                        textAlign: 'center',
                        position: 'relative',
                        borderWidth: 2,
                        borderColor: this.state.markErrorType === 'UDGAAET' ? '#1976d2' : '#e0e0e0',
                        background: this.state.markErrorType === 'UDGAAET' ? '#e8f2fc' : '#fff'
                      }}
                    >
                      {this.state.markErrorType === 'UDGAAET' && (
                        <CheckCircleIcon fontSize='small' style={{ position: 'absolute', top: 8, right: 8, color: '#1976d2' }} />
                      )}
                      <BlockIcon style={{ fontSize: 32, color: '#d32f2f', marginBottom: 8 }} />
                      <Typography variant='subtitle2' style={{ fontWeight: 700 }}>
                        Udgået
                      </Typography>
                      <Typography variant='caption' color='textSecondary'>
                        Kan ikke skaffes igen
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
                {this.state.markErrorType === 'RESTORDRE' && (
                  <TextField
                    label='Forventet uge (påkrævet)'
                    value={this.state.markErrorWeek}
                    onChange={e => this.setState({ markErrorWeek: e.target.value })}
                    required
                    fullWidth
                    margin='normal'
                    variant='outlined'
                    size='small'
                  />
                )}
              </DialogContent>
              <DialogActions style={{ padding: '16px 24px' }}>
                <Button onClick={this.closeMarkErrorDialog}>Annuller</Button>
                <Button
                  variant='contained'
                  color='primary'
                  disabled={!this.state.markErrorType || (this.state.markErrorType === 'RESTORDRE' && !this.state.markErrorWeek)}
                  onClick={this.buildMarkErrorPreviews}
                >
                  Forhåndsvis mails
                </Button>
              </DialogActions>
            </>
          )}
          {this.state.markErrorStep === 'preview' && (
            <>
              <DialogTitle style={{ paddingBottom: 0 }}>
                Gennemse og send beskeder
                <Typography variant='body2' color='textSecondary'>
                  {this.state.markErrorLoadingPreviews
                    ? 'Henter ordrer og kundedata...'
                    : `${this.state.markErrorPreviews.length} besked(er) klar - tilret om nødvendigt inden afsendelse`}
                </Typography>
              </DialogTitle>
              <DialogContent>
                {this.state.markErrorLoadingPreviews ? (
                  <Box display='flex' flexDirection='column' alignItems='center' p={5} gridGap={12}>
                    <CircularProgress size={32} />
                    <Typography variant='body2' color='textSecondary'>
                      Henter ordrer og kundedata...
                    </Typography>
                  </Box>
                ) : (
                  this.state.markErrorPreviews.map(preview => (
                    <Paper
                      key={preview.key}
                      variant='outlined'
                      style={{
                        padding: 16,
                        marginBottom: 16,
                        borderRadius: 8,
                        borderColor: !preview.hasOrder || preview.hasError ? '#f5c6cb' : '#e0e0e0',
                        background: !preview.hasOrder || preview.hasError ? '#fdecea' : '#fff'
                      }}
                    >
                      {!preview.hasOrder && (
                        <Box display='flex' alignItems='center' gridGap={8}>
                          <ReportProblemIcon fontSize='small' style={{ color: '#d32f2f' }} />
                          <Typography variant='body2' style={{ color: '#d32f2f' }}>
                            {preview.lineIndices.length} linje(r) uden tilknyttet ordre - ingen mail sendes, men note tilføjes.
                          </Typography>
                        </Box>
                      )}
                      {preview.hasOrder && preview.hasError && (
                        <Box display='flex' alignItems='center' gridGap={8}>
                          <ReportProblemIcon fontSize='small' style={{ color: '#d32f2f' }} />
                          <Typography variant='body2' style={{ color: '#d32f2f' }}>
                            Kunne ikke hente ordre/bruger for ordre {preview.OrderID}. Ingen mail sendes, note tilføjes.
                          </Typography>
                        </Box>
                      )}
                      {preview.hasOrder && !preview.hasError && (
                        <>
                          <Box display='flex' alignItems='center' justifyContent='space-between' mb={1}>
                            <Typography variant='subtitle2' style={{ fontWeight: 700 }}>
                              {preview.userName} <span style={{ fontWeight: 400, color: '#666' }}>({preview.userEmail})</span>
                            </Typography>
                            <Box display='flex' alignItems='center' gridGap={4}>
                              {preview.notificationType === 'MOBILE' ? (
                                <SmsIcon fontSize='small' color='action' />
                              ) : (
                                <MailOutlineIcon fontSize='small' color='action' />
                              )}
                              <Typography variant='caption' color='textSecondary'>
                                Ordre {preview.ConfirmationID}
                              </Typography>
                            </Box>
                          </Box>
                          <TextField
                            value={preview.message}
                            onChange={e => this.updateMarkErrorPreviewMessage(preview.key, e.target.value)}
                            multiline
                            rows={7}
                            fullWidth
                            variant='outlined'
                            size='small'
                          />
                        </>
                      )}
                    </Paper>
                  ))
                )}
              </DialogContent>
              <DialogActions style={{ padding: '16px 24px' }}>
                <Button
                  onClick={() => this.setState({ markErrorStep: 'select' })}
                  disabled={this.state.markErrorSending || this.state.markErrorLoadingPreviews}
                >
                  Tilbage
                </Button>
                <Button onClick={this.closeMarkErrorDialog} disabled={this.state.markErrorSending}>
                  Annuller
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  disabled={this.state.markErrorSending || this.state.markErrorLoadingPreviews}
                  onClick={this.sendMarkErrorPreviews}
                >
                  {this.state.markErrorSending ? 'Sender...' : 'Send og markér linjer'}
                </Button>
              </DialogActions>
            </>
          )}
        </Dialog>
      </React.Fragment>
    )
  }
}
